import Button from '@mui/material/Button';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import MenuItem from '@mui/material/MenuItem';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import React from 'react';
import { IoAddCircle, IoTrashBin } from 'react-icons/io5';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';


export default function AvailabilityActions({ addAvailabilityAction, deleteAvailabilityAction }) {

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popper' : undefined;

  return (
    <div>
      <Button
        aria-describedby={id}
        variant="contained"
        className="tw-bg-[#00aeef]"
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon/>}
      >
        Actions
      </Button>
      <Popper id={id} open={open} anchorEl={anchorEl} placement="bottom-start" disablePortal>
        <ClickAwayListener onClickAway={handleClose}>
          <Paper>
            <MenuItem
              onClick={() => {
                addAvailabilityAction.open();
                handleClose();
              }}
            >
              <div className="tw-flex tw-items-center tw-gap-4">
                <IoAddCircle />
                <span>Add Availability</span>
              </div>
            </MenuItem>
            <MenuItem
              onClick={() => {
                deleteAvailabilityAction.open();
                handleClose();
              }}
              disabled={deleteAvailabilityAction.disabled}
            >
              <div className="tw-flex tw-items-center tw-gap-4">
                <IoTrashBin />
                <span>Bulk Delete Availability</span>
              </div>
            </MenuItem>
          </Paper>
        </ClickAwayListener>
      </Popper>
    </div>
  );
}
